import { useCatalogResources } from '../../hooks/useCatalogResources';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Flex } from 'foundations-components/components/Flex';
import { AcademyContentCard } from './AcademyContentCard';
import { AcademyContentCardSkeleton } from './AcademyContentCardSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
function parseAcademyVideoUrl(url) {
  var _searchParams$get, _searchParams$get2, _searchParams$get3;
  const {
    searchParams,
    pathname
  } = new URL(url);
  const segments = pathname.split('/');
  const vts = parseInt((_searchParams$get = searchParams.get('vts')) !== null && _searchParams$get !== void 0 ? _searchParams$get : '', 10);
  const vte = parseInt((_searchParams$get2 = searchParams.get('vte')) !== null && _searchParams$get2 !== void 0 ? _searchParams$get2 : '', 10);
  const clipRange = !isNaN(vts) && !isNaN(vte) ? {
    startTime: vts,
    endTime: vte
  } : undefined;
  let resourceId;
  let type;

  // Track URLs: /tracks/{courseId}/{lessonId}/{contentId}
  // The clip is from a specific lesson, so extract the lessonId (2nd segment)
  const tracksIdx = segments.indexOf('tracks');
  if (tracksIdx !== -1 && segments[tracksIdx + 2]) {
    resourceId = parseInt(segments[tracksIdx + 2], 10);
    type = 'LESSON';
  } else {
    const lessonsIdx = segments.indexOf('lessons');
    const shortIdx = segments.indexOf('shortvideo');
    if (lessonsIdx !== -1 && segments[lessonsIdx + 1]) {
      resourceId = parseInt(segments[lessonsIdx + 1], 10);
      type = 'LESSON';
    } else if (shortIdx !== -1 && segments[shortIdx + 1]) {
      resourceId = parseInt(segments[shortIdx + 1], 10);
      type = 'SHORT_FORM_CONTENT';
    }
  }
  return {
    resourceId,
    type,
    clipRange,
    language: (_searchParams$get3 = searchParams.get('language')) !== null && _searchParams$get3 !== void 0 ? _searchParams$get3 : undefined
  };
}
export const AcademyClipCard = ({
  section
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const {
    resourceId,
    type,
    clipRange,
    language
  } = parseAcademyVideoUrl(section.url);
  const hasValidParams = resourceId != null && !isNaN(resourceId) && type != null;
  const {
    resources,
    loading,
    error
  } = useCatalogResources(hasValidParams ? [{
    resourceId,
    type,
    language: type === 'LESSON' ? language === null || language === void 0 ? void 0 : language.toLowerCase() : undefined
  }] : [], !hasValidParams);
  if (loading) {
    return /*#__PURE__*/_jsx(Flex, {
      marginBlockStart: "400",
      marginBlockEnd: isMobile ? '400' : undefined,
      children: /*#__PURE__*/_jsx(AcademyContentCardSkeleton, {})
    });
  }
  if (error || !(resources !== null && resources !== void 0 && resources.length)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    marginBlockStart: "400",
    marginBlockEnd: isMobile ? '400' : undefined,
    children: /*#__PURE__*/_jsx(AcademyContentCard, {
      model: resources[0],
      clipRange: clipRange,
      contentHref: section.url
    })
  });
};